module.exports = __webpack_public_path__ + "img/Indonesia-2-hover.4df7231a.jpg";